export * from "./address";
export * from "./cn";
export * from "./formatters";
export * from "./token.helper";

/**
 * Extracts error message from error object with fallback
 * @param error - Error object or unknown
 * @param fallback - Fallback message if no error message found
 * @returns Error message string
 */
export const getErrorMessage = (error: Error | unknown, fallback: string = 'An error occurred'): string => {
  if (error instanceof Error) {
    return error.message || fallback;
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error && typeof error === 'object' && 'message' in error) {
    return String((error as any).message) || fallback;
  }
  return fallback;
};
